import { useRef } from 'react';
import styles from './Auth.module.css';

/** Six single-character cells; auto-advance on entry, backspace to the previous cell. */
export function CodeInput({ value, onChange, disabled }: { value: string; onChange: (code: string) => void; disabled?: boolean }) {
  const refs = useRef<Array<HTMLInputElement | null>>([]);
  const cells = Array.from({ length: 6 }, (_, i) => value[i] ?? '');

  const set = (i: number, ch: string) => {
    const next = cells.slice();
    next[i] = ch;
    onChange(next.join(''));
  };

  return (
    <div className={styles.codeRow} role="group" aria-label="Verification code">
      {cells.map((ch, i) => (
        <input
          key={i}
          ref={(el) => {
            refs.current[i] = el;
          }}
          className={styles.codeCell}
          inputMode="numeric"
          autoComplete={i === 0 ? 'one-time-code' : 'off'}
          maxLength={1}
          value={ch}
          disabled={disabled}
          aria-label={`Digit ${i + 1}`}
          onChange={(e) => {
            const digits = e.target.value.replace(/\D/g, '');
            if (digits.length > 1) {
              onChange(digits.slice(0, 6));
              refs.current[Math.min(5, digits.length - 1)]?.focus();
              return;
            }
            set(i, digits);
            if (digits && i < 5) refs.current[i + 1]?.focus();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Backspace' && !ch && i > 0) {
              refs.current[i - 1]?.focus();
              set(i - 1, '');
              e.preventDefault();
            }
          }}
        />
      ))}
    </div>
  );
}
